import $ from 'jquery';

/**
 * @param {string} text
 */
export const copyTextToClipboard = async (text) => {

	// Use the new navigator.clipboard API if available
	if (navigator.clipboard) {
		try {
			await navigator.clipboard.writeText(text);
		}
		catch (error) {
			console.error('Failed to copy text to clipboard', error);
			mpro.toast('error', {
				title: 'Failed to copy text to clipboard',
				content: 'Please allow the browser to access the clipboard',
			});
		}
	}

	// Fallback to the old (deprecated) execCommand API
	else {
		const controller = document.createElement('textarea');
		controller.classList.add('ignore-focustrap');
		document.body.append(controller);
		// inp.style.width = 0;
		// inp.style.height = 0;
		// @ts-ignore
		controller.value = text;
		controller.select();
		document.execCommand('copy', false);
		controller.remove();
	}
};

/**
 * Copy text from target element
 *
 * @param {HTMLElement|Element} trigger
 */
export const copyTextFromElement = async (trigger) => {

	const $trigger = $(trigger);

	// Make sure the prev copy animation is finished
	$trigger.finish();

	// Get text to copy
	const dataset = $trigger.data();

	// First get the hardcoded text on the dataset
	let { copyText } = dataset;

	// Provided a selector, get the text from the element
	if (copyText.selector) {
		copyText = $(copyText.selector).map((_, elem) => {
			const $elem = $(elem);
			if ($elem.is('input, textarea')) {
				return $elem.val();
			}
			return $elem.text().trim();
		}).get().join('\n');
	}

	// Get text from the element, if not provided as string in the copyText variable
	else if (!copyText) {
		copyText = $trigger.text().trim();
	}

	// @ts-ignore
	const hasTooltip = $trigger[0]._tooltip || ($trigger.data('bsToggle') === 'tooltip');
	let initialText;
	const origToggle = dataset.bsToggle;
	const copiedText = mpro.langvar('copied_to_clipboard');

	// Get the tooltip title
	if (hasTooltip) {
		/** @type {import('../mpro/modules/mpro.tooltip').MpTooltip} */ // @ts-ignore
		const tooltip = $trigger[0]._tooltip;
		// @ts-ignore
		initialText = tooltip.getTitle();
		// Remove the old tooltip
		tooltip.dispose();
		// Remove the toggle element to prevent further tooltip creation
		$trigger.removeAttr('data-bs-toggle');
	}
	else {
		initialText = $trigger.attr('title');
	}

	// Copy the text
	await copyTextToClipboard(copyText);

	// Set the new tooltip
	// @ts-ignore
	$trigger.attr('title', copiedText).tooltip({ trigger: 'manual' }).tooltip('show');

	// Reset the tooltip with some delay
	$trigger.animate({ fakeProp: 1 }, 2000, () => {
		// Remove the new tooltip
		$trigger.tooltip('dispose');
		// Set the old tooltip
		$trigger.attr({
			title: initialText,
			'data-bs-toggle': origToggle,
		});
		// Reinitialize the tooltip
		if (hasTooltip) {
			$trigger.tooltip();
		}
	});
};
